import axios from 'axios'

// In production (foosfi.re), use relative URLs to go through Apache proxy
// In development, use localhost:3002
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1'
const API_BASE_URL = isProduction ? '' : (import.meta.env.VITE_API_URL || 'http://localhost:3002')

export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Note: We don't use interceptors here because we manually add tokens in each component
// This allows us to pass the correct audience and scope for each request
